import { jsx as _jsx } from "react/jsx-runtime";
import { Button, LinkTarget, IconName, IconSize, ButtonVariant, ButtonSize } from '@as/cotopaxi';
import { Stack } from '@yonderland/andes-react';
export const ProductCareCTA = ({ alt, buttonVariant, label, linkPath, targetIsBlank, horizontalAlign, }) => {
    const isLinkStyle = buttonVariant === ButtonVariant.LINK || buttonVariant === ButtonVariant.LINK_SUBTLE;
    const getJustify = () => {
        if (horizontalAlign === 'start')
            return 'start';
        if (horizontalAlign === 'end')
            return 'end';
        return 'center';
    };
    return (_jsx(Stack, { justify: getJustify(), children: _jsx(Button, { variant: buttonVariant, size: isLinkStyle ? ButtonSize.SMALL : ButtonSize.NORMAL, href: linkPath, target: targetIsBlank ? LinkTarget.BLANK : undefined, text: label, title: alt, iconRight: {
                name: IconName.CHEVRON_RIGHT,
                size: IconSize.MINOR,
            } }) }));
};
